module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/downloads/download-list/download-list.component.scss
// module id = ./libs/atenea-cms-brand/src/downloads/download-list/download-list.component.scss
// module chunks = main